export const TENOR_COL_ID = 'tenorId';
